import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import Sort from "../../assets/images/llantas/table/sort.svg";
import SortAsc from "../../assets/images/llantas/table/sort-asc.svg";
import SortDesc from "../../assets/images/llantas/table/sort-desc.svg";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';
import Loading from '../ui/Loading.js'
import {
	Table,
	TableContainer,
	TableHead,
	TableRow,
	TableBody,
	TablePagination,
} from '@material-ui/core';
import { StyledTableCell, StyledTooltip, rowsPerPage } from '../../commons/utils/TableStyles'
import * as Utils from '../../commons/utils/Utils';
import { FormattedMessage, useIntl } from 'react-intl';
import SafeFeedbackFormularioGridRow from './SafeFeedbackFormularioGridRow.jsx';
import SafeFeedbackFormularioGridFiltros from './SafeFeedbackFormularioGridFiltros.jsx';
import Security from '../../commons/security/Security'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import backendStrings from '../../lang/backendStrings.js';

const PAGINATION_INIT = {
	page: 0,
	count: 0,
	perPage: 10,
}

const FILTER_QUERY_INIT = {
	id: '',
	tipoFormulario: '',
	fecha: '',
	entidad: '',
	base: '',
	estado: 'PENDIENTE',
	dominio: '',
	transportadora: '',
	centroCostos: '',
	showInactivos: false,
}

const SORT_QUERY_INIT = {
	id: 'desc',
	fecha: '',
}

const COLUMNS_ENABLED_INIT = {
	icono: true,
	estado: true,
	id: true,
	tipoFormulario: true,
	fecha: true,
}

const getStorage = () =>{
	let storage = JSON.parse(window.localStorage.getItem('SafeFeedbackFormularioGridFilters'))
	if(storage && storage.activo){
		return true
	}else{
		return false
	}
}

const SafeFeedbackFormularioGrid = (props) => {
	const intl = useIntl();
	const filterEntidad = (new URLSearchParams(props.location.search)).get('entidad')

	const [formularios, setFormularios] = useState([]);
	const [loading, setLoading] = useState(false);
	const [pagination, setPagination] = useState({ ...PAGINATION_INIT });
	const [paginationCount, setPaginationCount] = useState(0);
	const [filterQuery, setFilterQuery] = useState(null);
	const [filterQueryLast, setFilterQueryLast] = useState(null);
	const [sortQuery, setSortQuery] = useState({ ...SORT_QUERY_INIT });
	const [searchActive, setSearchActive] = useState(false);
	const [columnsEnabled, setColumnsEnabled] = useState({ ...COLUMNS_ENABLED_INIT })
	const [dropdownActive, setDropdownActive] = useState(false);
	const [resetFilterInputs, setResetFilterInputs] = useState(false);
	const [redirectTo, setRedirectTo] = useState(null);
	const [persisteFiltros, setPersisteFiltros] = useState(getStorage())
	const [summaryAlerts, setSummaryAlerts] = useState(null)
	const [filterResetInputs, setFilterResetInputs] = useState(false)
	const [filterKpi, setFilterKpi] = useState(null);
	
	const transportadoraGrilla = ConfigBusiness.get('moviles.transportadora.grilla') === 'true';

	useEffect(() => {
		setLoading(true)
		if (Security.hasPermission("SAFEFEEDBACK_LISTAR")) {
			filterQuery && init()
		} else {
			setRedirectTo("/error")
		}
		return () => { }
	}, [pagination, filterQuery, sortQuery])

	const init = () => {
		const formulariosGridReq = Utils.getData(`/safe-feedback-formularios${getQuery()}`);
		const controlesGridReq = Utils.getData(`/safe-feedback-formularios/controles/alarmas`);
		Promise.all([formulariosGridReq, controlesGridReq])
			.then(([formulariosGrid, controlesGrid]) => {
				setFormularios(formulariosGrid.formularios);
				setPaginationCount(formulariosGrid.pagination.count);
				setSummaryAlerts(controlesGrid);
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false)
			})
	};

	const getQuery = () => {
		let query = "?page=" + pagination.page
		query += "&perPage=" + pagination.perPage
  
		query += "&estado=" + filterQuery.estado
		query += "&id=" + filterQuery.id
		query += "&tipoFormulario=" + filterQuery.tipoFormulario
		query += "&fecha=" + filterQuery.fecha
		query += "&dominio=" + filterQuery.dominio
		query += "&base=" + filterQuery.base
		query += "&showInactivos=" + filterQuery.showInactivos

		if (transportadoraGrilla) {
			query += "&transportadora=" + filterQuery.transportadora
			query += "&centroCostos=" + filterQuery.centroCostos
		}

		// Ordenamiento
		query += '&idSort=' + sortQuery.id
		query += '&fechaSort=' + sortQuery.fecha

		return query
	}
	const handlePageChange = (event, newPage) => {
		setPagination({ ...pagination, page: newPage });
	}

	const handleRowsPerPageChange = (event) => {
		setPagination({ ...pagination, perPage: parseInt(event.target.value, 10), page: 0 });
	}

	const handleSort = (key) => {
		let query = { ...sortQuery }
		let orden = (sortQuery[key] == '' || sortQuery[key] === 'desc') ? 'asc' : 'desc';

		query['id'] = '';
		query['tipoFormulario'] = '';
		query['fecha'] = '';

		query[key] = orden;
		setSortQuery(query);
	}

	const handleFilterReset = () => {
		setPagination(PAGINATION_INIT);
		setFilterQuery(FILTER_QUERY_INIT);
		setSortQuery(SORT_QUERY_INIT);
		setDropdownActive(false);
		setSearchActive(false);
		setResetFilterInputs(true);
		setFilterResetInputs(true)
	};

	const handleFilterChange = () => {
		setPagination(prevState => ({ ...prevState, page: 0 }));
	}

	const reloadData = () => {
		setLoading(true);
		init()
	};

	const handleFilterDashboard = (filter) => {
		switch (filter) {
			case 'PENDIENTE':
				filterQuery.estado = 'PENDIENTE';
				break;
			case 'CONFIRMADO':
				filterQuery.estado = 'CONFIRMADO';
				break;
			case 'DESESTIMADO':
				filterQuery.estado = 'DESESTIMADO';
			break;
			default:
				break;
	  	}
		setFilterKpi(filter);
	  	reloadData();
	}

	return (
		<>
			{redirectTo && <Redirect push to={redirectTo} />}
			{loading && <Loading />}
			{summaryAlerts ?
				<section className="combustiblesWidget">
					<div className="row justify-content-around">
						{summaryAlerts.map((alert, index)=>{
							return(
								<div key={index} className={"col-xl-4 col-lg-6 col-12"} style={{ paddingRight: "0.5rem", paddingLeft: "0.5rem" }}>
									<div className="card pull-up">  
										<div className="card-content" style={{ cursor: alert.cursor }}>
											<div style={{padding: "15px"}} className="card-body"  onClick={alert.cursor === 'pointer' ? (e) => handleFilterDashboard(alert.filter) : null}>
												<div className="media d-flex">
													<div className="align-self-center">
														<i className={alert.iconClass} style={{color: alert.iconColor}}></i>
													</div>
													<div className="media-body text-right">
														<span><FormattedMessage {...(backendStrings[alert.description] ? backendStrings[alert.description] : backendStrings['errors.default'])}/></span>
														<h3><b>{!alert.value ? 0 : alert.value }</b></h3>
													</div>
												</div>
												
											</div> 
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</section>
			: ''}
			<div className="card">
				<div className="card-content">
					<div className="card-body card-dashboard">
						<div className="container-fluid mb-1">
							<div className="row dt-icons" style={{ width: '100%' }}>
								<div className="col">
									<div
										className="btn btn-grey-blue box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
										style={{ height: 52, marginLeft: '-13px', marginTop: '6px' }}
										onClick={() => setDropdownActive(!dropdownActive)}
									>
										{dropdownActive ? <UpIcon /> : <ExpandMoreIcon />}
									</div>
								</div>
								<div className="col">
									{searchActive && (
										<div className="btn-dt-main round-icon">
											<div
												className="text-center"
												style={{
													height: '25px',
													borderRadius: '3px',
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													paddingLeft: '8px',
													backgroundColor: '#5AAC43',
													color: 'white',
												}}
											>
												<div
													className="text-center"
													style={{
														width: '100%',
														fontSize: '12px',
														fontWeight: '500',
													}}
												>
													{formularios.length} de {paginationCount} resultados de busqueda
												</div>
												<div className="resultados-busqueda-notif">
													<i
														className="las la-times la-xs cursor-pointer"
														onClick={() => handleFilterReset()}
													></i>
												</div>
											</div>
										</div>
									)}
								</div>
								<div className="col">
								</div>
							</div>
						</div>

						<SafeFeedbackFormularioGridFiltros
							columnsEnabled={columnsEnabled}
							resetFilterInputs={resetFilterInputs}
							setResetFilterInputs={setResetFilterInputs}
							filterQuery={filterQuery}
							filterQueryLast={filterQueryLast}
							setFilterQuery={setFilterQuery}
							setDropdownActive={setDropdownActive}
							dropdownActive={dropdownActive}
							searchActive={searchActive}
							setSearchActive={setSearchActive}
							filterEntidad={filterEntidad}
							handleFilterChange={handleFilterChange}
							persisteFiltros={persisteFiltros}
							setFilterResetInputs={setFilterResetInputs}
							filterResetInputs={filterResetInputs}
							filterKpi={filterKpi}
							transportadoraGrilla={transportadoraGrilla}
							setPersisteFiltros={setPersisteFiltros}
						/>

						<TableContainer>
							<Table>
								<TableHead>
								<TableRow>
									<StyledTableCell
										align="left"
										style={{ cursor: 'pointer' }}
										onClick={() => handleSort('id')}
									>
									<FormattedMessage
										id="formularioGrid.render.column_id.label"
										defaultMessage="Id"
									/>
									<img
										className="ml-1"
										src={
										sortQuery.id === '' ? Sort : sortQuery.id === 'asc' ? SortAsc : SortDesc
										}
										alt={'/'}
										style={{ height: '12px', width: '22px' }}
									/>
									</StyledTableCell>

									<StyledTableCell align="left">
									<FormattedMessage
										id="safeFeedbackFormularioGrid.render.table_column_tipoFormulario"
										defaultMessage="Tipo de Formulario"
									/>
									</StyledTableCell>

									<StyledTableCell
										align="left"
										style={{ cursor: 'pointer' }}
										onClick={() => handleSort('fecha')}
									>
									<FormattedMessage
										id="safeFeedbackFormularioGrid.render.table_column_fechaHora"
										defaultMessage="Fecha y Hora"
									/>
									<img
										className="ml-1"
										src={
										sortQuery.fecha === ''
											? Sort
											: sortQuery.fecha === 'asc'
											? SortAsc
											: SortDesc
										}
										alt={'/'}
										style={{ height: '12px', width: '22px' }}
									/>
									</StyledTableCell>
									<StyledTableCell align="left">
									<FormattedMessage
										id="safeFeedbackFormularioGrid.render.table_column_base"
										defaultMessage="Base"
									/>
									</StyledTableCell>
									<StyledTableCell align="left">
									<FormattedMessage
										id="safeFeedbackFormularioGrid.render.table_column_placa"
										defaultMessage="Placa"
									/>
									</StyledTableCell>
									<StyledTableCell align="left">
										<FormattedMessage
											id="safeFeedbackFormularioGrid.render.table_column_transportadora"
											defaultMessage="Transportadora"
										/>
									</StyledTableCell>
									<StyledTableCell align="left">
										<FormattedMessage
											id="safeFeedbackFormularioGrid.render.table_column_centroCostos"
											defaultMessage="Centro de Costos"
										/>
									</StyledTableCell>
									<StyledTableCell align="left">
									<FormattedMessage
										id="safeFeedbackFormularioGrid.render.table_column_acciones"
										defaultMessage="Acciones"
									/>
									</StyledTableCell>
								</TableRow>
								</TableHead>
								<TableBody>
								{loading && (
									<TableRow>
									<StyledTableCell colSpan={11} align="center">
										<FormattedMessage
										id="Cargando"
										defaultMessage="Cargando"
										/>
									</StyledTableCell>
									</TableRow>
								)}
								{!loading &&
									formularios &&
									formularios.map((formulario) => (
										<SafeFeedbackFormularioGridRow
											key={'safeFeedbackFormularioGridRow_' + formulario.id}
											baseUrl={props.match.url}
											formulario={formulario}
											columnsEnabled={columnsEnabled}
											loading={loading}
											setLoading={setLoading}
											reloadData={reloadData}
											persisteFiltros={persisteFiltros}
											intl={intl}
										/>
									))}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							rowsPerPageOptions={rowsPerPage}
							component="div"
							count={paginationCount}
							rowsPerPage={pagination.perPage}
							page={pagination.page}
							onPageChange={handlePageChange}
							onRowsPerPageChange={handleRowsPerPageChange}
							labelRowsPerPage="Mostrar"
							labelDisplayedRows={({ from, to, count }) => `Mostrando ${from} a ${to} de ${count}`}
						/>
					</div>
				</div>
			</div>
		</>
  	);
}

export default SafeFeedbackFormularioGrid;
